// src/components/Services/Services.jsx
import React from 'react';
import { FaCarRear, FaLightbulb, FaMicrophone, FaBoxOpen } from "react-icons/fa6";
import { GrInstall } from "react-icons/gr";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import ResponsiveButton from "../ResponsiveButton/ResponsiveButton"; // <-- tuo nappi-komponentti

const skillsData = [
  {
    name: "Kuljetuspalvelu ja peräkärryn vuokraus",
    anchor: "kuljetuspalvelu",
    icon: <FaCarRear className="text-5xl text-darkest dark:text-primary drop-shadow-[1px_10px_5px_rgba(0,0,0,0.40)]" />,
    description: "Tutustu kuljetuspalveluumme ja HIRVI 350 -peräkärryn vuokraukseen.",
  },
  {
    name: "Asennus- ja opastuspalvelu",
    anchor: "opastuspalvelu",
    icon: <GrInstall className="text-5xl text-darkest dark:text-primary drop-shadow-[1px_10px_5px_rgba(0,0,0,0.40)]" />,
    description: "Laitteet käyttövalmiiksi ja selkeät käyttöohjeet suoraan tapahtumapaikalla.",

  },
  
  {
    name: "Koko illan tekninen toteutus",
    anchor: "valojaanen",
    icon: <FaLightbulb className="text-5xl text-darkest dark:text-primary drop-shadow-[1px_10px_5px_rgba(0,0,0,0.40)]" />,
    description: "Spiderlegs suunnittelee ja toteuttaa koko illan äänentoiston ja valaistuksen – stressittömät juhlat taattuna!",
  },
  
  {
    name: "Bändit & Esiintyjät",
    anchor: "bandit",
    icon: <FaMicrophone className="text-5xl text-darkest dark:text-primary drop-shadow-[1px_10px_5px_rgba(0,0,0,0.40)]" />,
    description: "Löydä esiintyjä helposti ja nopeasti – buukkaa ammattilainen tapahtumaasi!",
  },

  {
    name: "Liity vuokraajaksi",
    anchor: "liity-vuokraajaksi",
    icon: <FaBoxOpen className="text-5xl text-darkest dark:text-primary drop-shadow-[1px_10px_5px_rgba(0,0,0,0.40)]" />,
    description: "Onko sinulla käyttämättömiä laitteita? Vuokraa ne ja tienaa – liity mukaan helposti!",
  },
];

const Services = () => {
  React.useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="pb-20">
      <span id="about"></span>

      <div className="ml-4 mr-4 flex dark:bg-violet bg-primary dark:bg-opacity-75 bg-opacity-75 rounded-3xl pb-10 p-5 2xl:mx-72">
        <div className="container">
          {/* Otsikko */}
          <div className="flex flex-row items-center">
            <h2
              data-aos="fade-up"
              className="font-customFont2 dark:text-shadow-xxl text-left text-darkest dark:text-primary text-5xl sm:text-6xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-6xl font-bold leading-tight"
            >
              Miksi valita meidät?
            </h2>
          </div>

          {/* Sivun kuvaus */}
          <p
            className="font-customFont1 text-shadow-lg text-left text-darkest dark:text-primary text-xl font-light pb-10"
            data-aos="fade-up"
          >
            Varmista unohtumaton elämys häihin, yritysjuhliin tai teemabileisiin
            hyödyntämällä monipuolisia palveluitamme. Tarjoamme kattavan valikoiman
            laadukkaita ratkaisuja, joiden avulla tunnelma pysyy korkealla läpi koko
            tapahtuman. Uutena lisänä olemme juuri lanseeranneet bändien ja artistien
            välityspalvelun – näin löydät helposti esiintyjän joka kruunaa juhlat!
          </p>

          {/* Lista palveluista */}
          <div>
            <div className="grid grid-cols-1 sm:grid-cols-2  md:grid-cols-3 s24:grid-cols-1 xsm:grid-cols-1 mdd:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-3 gap-3">
              {skillsData.map((skill) => (
                <div
                  key={skill.name}
                  data-aos="fade-up"
                  className="card text-center group space-y-3 sm:space-y-6 p-5  bg-white bg-opacity-50 hover:bg-lightbg hover:bg-opacity-60 rounded-3xl relative group cursor-pointer flex flex-col"
                >
                  <div className="grid place-items-center">{skill.icon}</div>
                  <h2 className="font-customFont2 dark:text-shadow-lg text-center text-darkest dark:text-primary text-3xl sm:text-3xl md:text-3xl lg:text-3xl xl:text-3xl font-normal leading-[1.2]">
                    {skill.name}
                  </h2>
                  <p className="font-customFont1 dark:text-shadow-lg text-center text-darkest dark:text-primary text-xl font-normal flex-grow">
                    {skill.description}
                  </p>

                  <div className="mt-auto grid place-content-center">
                    {/* Käytetään ankkuria /palvelut#kuljetuspalvelu, jne. */}
                    <Link
                      to={`/palvelut#${skill.anchor || ''}`}
                      onClick={() =>
                        window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
                      }
                    ><ResponsiveButton className="w-36" variant="servicesreadmore">
                    Lue lisää!
                  </ResponsiveButton>
                  
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
